define('authui/login/controllers/loginController', [
    'base/utils/iamHttpService',
    'language/resource',
    'authui/iamUtils',
    'authui/iamEnv',
    'base/utils/preVerifycodeUtil',
    'base/utils/cookie',
    'base/utils/utility',
    'qrcode'
],
function (iamHttpService, i18n, iamUtils, iamEnv, perVerifycodeUtil, cookieOp, utils, QRCode) {
    'use strict';
       
    var QRCODE_VALID_TIME = 120; //二维码失效时间，单位秒
    var loginCtrl = function ($scope, $sce, $filter, $interval, $timeout, securityPolicy, $state) {
        $scope.$sce = $sce;
        if(localStorage.getItem('fromUpgrade') === 'true'){
            var service = utils.getUrlParams().service;
            service !== undefined ? service = 'https://auth.huaweicloud.com/authui/logout?service=' + service : service = 'https://auth.huaweicloud.com/authui/logout';
            var redirectUrl = 'https://id1.cloud.huawei.com/AMW/logout' + '?service=' + service;
            window.location.href = redirectUrl;
            localStorage.removeItem('fromUpgrade');
            return;
        }
        if (window.navigator.userAgent.toLowerCase().indexOf('hwidoauthsdk_ver') === -1) {
            document.title = i18n('titles.login');
        }

        try{
            iamUtils.initialCloudBI('/authui/#/login',{C1:'IAM-Login'});
        }catch(e){
            console.dir(e)
        }

        window.TinyMonitor && window.TinyMonitor.reportCustomTime('rtti','IAM-Login', 1);
        if (!window.TinyMonitor) {
            let interval = setInterval(
                () => {
                    if (window.TinyMonitor) {
                        window.TinyMonitor.reportCustomTime('rtti','IAM-Login', 1);
                        clearInterval(interval);
                    }
                },
                1000
            );
        }
        
        isLogin($scope); // 判断是否已经有登录
        getSDKBaseInfo($scope);
        
        $scope.i18n = i18n;
        $scope.securityPolicy = securityPolicy;
        $scope.ipIsInternational = iamUtils.ipIsInternational();// 是否为国际IP
        $scope.cbcRiskcheckAddress = 'https://res.hc-cdn.com/riskcontrol-accountguard/1.0.7/riskIntegrated/cn/accountguard.js?t=' + new Date().getTime();
        $scope.model = {
            language: window.language,
            isMobile: window.outerWidth > 500 ? false : true,
            isLiteSDK: window.navigator.userAgent.toLowerCase().indexOf('hwidoauthsdk_ver') === -1 ? false : true,
            isCompany: false, //是否是IAM用户登录,true:IAM用户，false:帐号
            loginType: 'account',
            // 国家码相关
            defaultCode: '0086',
            privacyLink: '', //隐私信息了解更多链接地址，通过js-sdk获取
            showCookie: true, // 是否显示底部cookie提示
            sdkLoading: true,
            registUrl: getRegistUrl($scope),
            hasHwCloudLink: iamUtils.CONFIG.hasHwCloudLink === 'true',
            chkTxt: i18n('rememberName'),
            rememberChecked: cookieOp.getCookie('rememberChecked') ? true : false,
            rememberCheckedChange: function(){
                $scope.model.rememberChecked = !$scope.model.rememberChecked;
            },
        };

        $scope.domainErrorMsgObj = {
            'accountNameBlank': i18n('accountNameBlank'),
            'domainWrong': i18n('wrongNamePwd'),
        }

        $scope.usernameErrorMsgObj = {
            'userNameBlank': i18n('userNameBlank'),
            'domainWrong': i18n('wrongNamePwd'),
        }

        $scope.nameOrPwdErrorMsgObj = {
            '401': i18n('wrongNamePwd'),
            '402': i18n('wrongNamePwdoneChances'),
            '403': i18n('wrongNamePwdTwoChances'),
            '404': i18n('wrongNamePwdThreeChances'),
            '405': i18n('wrongNamePwdFourChances'),
            '412': i18n('loginReactivateFail'),
            '413': i18n('userAccountsLocked'),
            '414': i18n('domainuserAccountsLocked'),
            '415': i18n('userAccountsLocked'),
        };

        $scope.pwdErrorMsgObj = {
            '406': i18n('invalidInput'),
            '407': i18n('invalidInputoneChances'),
            '408': i18n('invalidInputTwoChances'),
            '409': i18n('invalidInputThreeChances'),
            '410': i18n('invalidInputFourChances'),
            '420': i18n('userAccountsStopped'),
            '423': i18n('serviceUrlInvalid'),
            '424': i18n('maxSessionLimit'),
            '427': i18n('multiUserInvalid'),
            '428': i18n('accountClosed'),
            '430': i18n('hasBindUniportal'),
            '432': i18n('pageTimeout'),
            '508121000': i18n('wrongIPBlacklist'),
            '508121001': i18n('wrongIPFrequencyLimiting'),
            '508121002': i18n('wrongEquipmentIDFrequencyLimiting'),
            '508121003': i18n('MachineOperation'),
            'pwdBlank': i18n('pwdBlank'),
        }

        $scope.verifycodeErrorMsgObj = {
            '411': i18n('wrongVerifyCode'),
            '418': i18n('verifyCode.error'),
            '419': i18n('verifyCode.invalid'),
            'checkCodeBlank': i18n('checkCodeBlank'),
        }

        $scope.errorMsgObj = {
            '417': i18n('systemException'),
            'IAM.0012': i18n('operationTooFrequent'),
            'IAM.0004': i18n('pageTimeout'),
            'IAM.1063': i18n('wrongVerifyCode'),
            'IAM.1065': i18n('domainAccountsStopped'),
            'IAM.1066': i18n('quickLogin.notActivate'),
            'IAM.0018': i18n('invalidInput'),
            'IAM.0007': i18n('invalidInput'),
            'noIdps': i18n('idpLogin.noIdps'),
            'operationTooFrequent': i18n('operationTooFrequent'),
            'domainNotExist': i18n('idpLogin.domainNotExist'),
            'idpIpLock': i18n('mobileLoginModel.operationTooFrequent'),
        };

        $scope.getErrorInfo = function (errorCode) {
            return $scope.errorMsgObj[errorCode] || i18n('systemException');
        }

        // IAM用户登录方式下 帐号名输入框
        $scope.IAMAccountInput = {
            id: 'IAMAccountInputId',
            value: '',
            oldValue: '',
            focused: false,
            ph: i18n('hwId.accountPlaceHolder'),
            disable: false,
            maxLength: 255,
            style: {
                width: iamUtils.layout.loginInputFiledWidth,
                height: iamUtils.layout.loginInputFieldHeight,
            },
            clear: function() {
                $scope.IAMAccountInput.value = '';
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            },
            change: function () {
                // 内容修改则清空密码
                $scope.IAMPasswordInput.value = '';
                hideErrorMsg($scope);
                setLoginBtn($scope);
            },
            blur: function () {
                send2CloudBISafe('input', 'change', 'login_company_accountName', $scope.IAMAccountInput.value.trim());
                if (!$scope.IAMAccountInput.value || $scope.IAMAccountInput.value === $scope.IAMAccountInput.oldValue) {
                    return;
                }
                $scope.IAMAccountInput.value = $scope.IAMAccountInput.value.trim();
                $scope.IAMAccountInput.oldValue = $scope.IAMAccountInput.value;
                loginVerify($scope);
                hideErrorMsg($scope);
            },
            getFocus: function () {
                setTimeout(function () {
                    $('#' + $scope.IAMAccountInput.id)[0].focus();
                }, 100)
            }
        };

        // IAM用户登录方式下 用户名输入框
        $scope.IAMUsernameInput = {
            type: 'text',
            id: 'IAMUsernameInputId',
            value: '',
            oldValue: '',
            focused: false,
            ph: i18n('HongKongUserNamePlaceHolder'),
            disable: false,
            style: {
                width: iamUtils.layout.loginInputFiledWidth,
                height: iamUtils.layout.loginInputFieldHeight,
            },
            maxLength: 255,
            clear: function() {
                $scope.IAMUsernameInput.value = '';
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            },
            change: function () {
                // 内容修改则清空密码
                $scope.IAMPasswordInput.value = '';
                hideErrorMsg($scope);
                setLoginBtn($scope);
            },
            blur: function () {
                send2CloudBISafe('input', 'change', 'login_company_userName', $scope.IAMUsernameInput.value.trim());
                if (!$scope.IAMUsernameInput.value || $scope.IAMUsernameInput.value === $scope.IAMUsernameInput.oldValue) {
                    return;
                }
                $scope.IAMUsernameInput.value = $scope.IAMUsernameInput.value.trim();
                $scope.IAMUsernameInput.oldValue = $scope.IAMUsernameInput.value;
                loginVerify($scope);
                hideErrorMsg($scope);
            },
            getFocus: function () {
                setTimeout(function () {
                    $scope.IAMAccountInput.blur();
                    $('#' + $scope.IAMUsernameInput.id)[0].focus();
                }, 100)
            }
        };

        // IAM用户登录方式下 密码输入框
        $scope.IAMPasswordInput = {
            type: 'password',
            id: 'IAMPasswordInputId',
            value: '',
            focused: false,
            ph: i18n('iamPasswdPlaceHolder'),
            pwdVisible: false,
            maxLength: 128,
            style: {
                width: iamUtils.layout.loginInputFiledWidth,
                height: iamUtils.layout.loginInputFieldHeight,
            },
            pwdValidator: [iamUtils.validator.childValidator.limitLength(128)],
            pwdFocused: false,
            change: function () {
                hideErrorMsg($scope);
                setLoginBtn($scope);
            },
            pwdVisibleFunc: function () {
                $scope.IAMPasswordInput.pwdVisible = !$scope.IAMPasswordInput.pwdVisible;
                var type = $scope.IAMPasswordInput.pwdVisible ? 'text' : 'password';
                $('#' + $scope.IAMPasswordInput.id).attr('type', type);
            },
            getFocus: function () {
                setTimeout(function () {
                    $scope.IAMAccountInput.blur();
                    $('#' + $scope.IAMPasswordInput.id)[0].focus();
                }, 100)
            },
            pwdBlur: function () {
                send2CloudBISafe('input', 'change', 'login_company_password', '***');
            },
        };

        // IAM用户登录方式下 图形验证码
        $scope.IAMVerifyCode = {
            isNeedVerifyCode: false,
            checkCodeId: 'checkCodeId',
            checkCode: '',
            maxLength: 4,
            focused: false,
            style: {
                width: '240px',
                height: iamUtils.layout.loginInputFieldHeight,
            },
            checkCodePH: i18n('verifyCodePlaceHolder'),
            checkCodeTip: i18n('getVerifyCode'),
            verifycode: '/authui/verifycode?index=1&alt=' + Math.random(),
            preValidVerifyCode: function () {
                var img = $('#validresultImg');
                perVerifycodeUtil.preValidVerifyCode(img, $scope.IAMVerifyCode.checkCode, '1', preValidCallback, iamHttpService, i18n);
                setLoginBtn($scope);
            },
            preValidVerifyCodeBlur: function () {
                send2CloudBISafe('input', 'change', 'login_company_personal_VerifyCode', $scope.IAMVerifyCode.checkCode);
                $scope.IAMVerifyCode.focused = false;
            },
            focus: function () {
                $scope.IAMVerifyCode.focused = true;
            },
            getVerifyCode: function () {
                send2CloudBISafe('button', 'click', 'login_company_getVerifyCode', '');
                var verifyCodeImg = $('#inputVerifyCodeImg')[0];
                if (verifyCodeImg) {
                    verifyCodeImg.src = '/authui/verifycode?index=1&alt=' + Math.random();
                }
                $scope.IAMVerifyCode.checkCode = '';
                $('#validresultImg').hide();
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            },
        };

        // IAM用户登录按钮
        $scope.loginBtn = {
            submitBtnText: i18n('loginSubmit'),
            disable: false,
            loginClick: function () {
                send2CloudBISafe('button', 'click', 'login_company', '');
                onSubmitBtnClick($scope);
            }
        };

        // IAM用户登录报错信息
        $scope.IAMLoginErrorMsg = {
            show: false,
            content: '',
            goLoginShow: false,
            goLoginHref: 'https://' + 'auth-intl.huaweicloud.com' + '/authui/?locale=' + window.language,
            goLoginContent: '',
            domainError: false,
            usernameError: false,
            pwdError: false,
            nameOrPwdError: false,
            verifycodeError: false,
        }

        // 扫码登录相关
        $scope.QRLoginModel = {
            hasQRLogin: (iamUtils.CONFIG.hasQrlogin === 'true' ? true : false) && !$scope.model.isMobile && !$scope.model.isLiteSDK && $scope.model.language === 'zh-cn', 
            isQRLogin: false,
            QRLoginTitle: i18n('QRLogin.title1'),
            remainingTime: iamUtils.i18nFormat(i18n('QRLogin.remainingTime'), QRCODE_VALID_TIME),
            countDownTipSuffix: i18n('QRLogin.countDownTipSuffix'),
            countDownInterval: null,
            pollingInterval: null,
            QRCodeInvalid: false,
            QRCodeStatus: 'new', //new, authorizing, refused, authorized
            downloadUrl: getDownloadUrl(),
            clientKey: '', //二维码标识
            QRLoginTypeSwitch: function(isQRLogin){
                if($scope.QRLoginModel.isQRLogin === isQRLogin) return;
                $scope.QRLoginModel.isQRLogin = isQRLogin;
                if($scope.QRLoginModel.isQRLogin){
                    //切换到扫码登录
                    send2CloudBISafe(iamUtils.pages.login, 'click_QRLogin');
                    QRCodeInit($scope, $timeout, $interval, iamUtils, send2CloudBISafe);
                } else {
                    //切换到账号登录
                    $interval.cancel($scope.QRLoginModel.pollingInterval);
                }
            },
            refreshQRCode: function(){
                QRCodeInit($scope, $timeout, $interval, iamUtils, send2CloudBISafe);
            }
        }

        // 快捷登录start
        $scope.quickLoginModel = {
            hasQuickLogin: false,
            loginTip: i18n('quickLogin.loginTip'),
            showSelectStep: false,
            loginType: 'mobile',
            loginTypeChange: function (type) {
                $scope.quickLoginCode.error = '';
                if (type == 'email') {
                    $scope.quickLoginModel.loginType = 'email';
                    $scope.quickLoginCode.ph = i18n('quickLogin.emailCodePH');
                } else {
                    $scope.quickLoginModel.loginType = 'mobile';
                    $scope.quickLoginCode.ph = i18n('quickLogin.smsCodePH');
                }
            }
        }

        // 快捷登录 手机、邮箱、账号名输入框
        $scope.quickAccountInput = {
            id: 'quickAccountInputId',
            value: '',
            oldValue: '',
            type: '',
            focused: false,
            error: '',
            ph: i18n('quickLogin.accountInputPH'),
            disable: false,
            maxLength: 255,
            style: {
                height: iamUtils.layout.loginInputFieldHeight,
            },
            clear: function () {
                $scope.quickAccountInput.value = '';
                $scope.quickAccountInput.oldValue = '';
                $scope.quickAccountInput.error = '';
                $scope.quickLoginUsers.hasDropdown = false;
                $scope.quickLoginCode.reset();
                $scope.quickLoginModel.loginTip = i18n('quickLogin.loginTip');
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            },
            change: function () {
                $scope.quickAccountInput.oldValue = '';
                $scope.quickAccountInput.error = '';
                $scope.quickLoginCode.reset();
                $scope.quickLoginModel.loginTip = i18n('quickLogin.loginTip');
                if ($scope.quickLoginUsers.hasSelected) {
                    $scope.quickLoginUsers.hasSelected = false;
                    $scope.quickLoginUsers.hasDropdown = false;
                    $scope.quickAccountInput.clear();
                }
            },
            focus: function () {
                $scope.quickAccountInput.focused = true;
            },
            blur: function () {
                $scope.quickAccountInput.focused = false;
                if ($scope.quickAccountInput.value == '' || $scope.quickAccountInput.oldValue == $scope.quickAccountInput.value || $scope.quickLoginUsers.hasSelected) {
                    return;
                }
                var type = 'name';
                var emailPattern = iamUtils.EmailRegex;
                var phonePattern = /^[0-9]\d*$/;
                if(phonePattern.test($scope.quickAccountInput.value)){
                    type = 'mobile';
                }else if(emailPattern.test($scope.quickAccountInput.value)){
                    type = 'email';
                }
                getUserList($scope, type);
            },
            getFocus: function () {

            }
        };

        // 快捷登录方式下 验证码
        $scope.quickLoginCode = {
            id: 'quickLoginCodeId',
            value: '',
            focused: false,
            emailBtnDisabled: true,
            mobileBtnDisabled: true,
            emailInterval: {},
            mobileInterval: {},
            emailBtnTxt: i18n('quickLogin.codeBtn'),
            mobileBtnTxt: i18n('quickLogin.codeBtn'),
            error: '',
            style: {
                width: '240px',
                height: iamUtils.layout.loginInputFieldHeight,
            },
            ph: i18n('quickLogin.smsCodePH'),
            focus: function () {
                $scope.quickLoginCode.focused = true;
            },
            blur: function () {
                $scope.quickLoginCode.focused = false;
            },
            change: function () {
                $scope.quickLoginCode.error = '';
            },
            reset: function () {
                $scope.quickLoginCode.value = '';
                $scope.quickLoginCode.error = '';
                $scope.quickLoginCode.emailBtnDisabled = true;
                $scope.quickLoginCode.mobileBtnDisabled = true;
                $scope.quickLoginCode.emailBtnTxt = i18n('quickLogin.codeBtn');
                $scope.quickLoginCode.mobileBtnTxt = i18n('quickLogin.codeBtn');
                $interval.cancel($scope.quickLoginCode.emailInterval);
                $interval.cancel($scope.quickLoginCode.mobileInterval);
            },
            getVerifyCode: function () {
                var type = $scope.quickLoginModel.loginType;
                if (type === 'mobile' && $scope.quickLoginCode.mobileBtnDisabled) {
                    return;
                }
                if (type === 'email' && $scope.quickLoginCode.emailBtnDisabled) {
                    return;
                }
                if (type === 'mobile' && !$scope.quickLoginUsers.selectedUser.mobile) {
                    $scope.quickLoginModel.loginTip = i18n('quickLogin.noMobile');
                    return;
                }
                if (type === 'email' && !$scope.quickLoginUsers.selectedUser.email) {
                    $scope.quickLoginModel.loginTip = i18n('quickLogin.noEmail');
                    return;
                }
                $scope.quickLoginCode.error = '';
                var params = {
                    type: type,
                    userId: $scope.quickLoginUsers.selectedUser.userid,
                }
                if (type === 'mobile') {
                    $scope.quickLoginCode.mobileBtnDisabled = true;
                } else {
                    $scope.quickLoginCode.emailBtnDisabled = true;
                }
                iamHttpService.get({
                    url: '/authui/sendlogincode',
                    params: params
                }).then(function (data) {
                    quickLoginCountDown($scope, $interval, iamUtils);
                    if (params.type === 'mobile') {
                        $scope.quickLoginModel.loginTip = iamUtils.i18nFormat(i18n('quickLogin.smsCodeMsg'), $scope.quickLoginUsers.selectedUser.mobile);
                    } else {
                        $scope.quickLoginModel.loginTip = iamUtils.i18nFormat(i18n('quickLogin.emailCodeMsg'), $scope.quickLoginUsers.selectedUser.email);
                    }
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                }, function (data) {
                    var response = typeof data.responseText === 'object' ? data.responseText : $.parseJSON(data.responseText);
                    $scope.quickLoginCode.error = $scope.getErrorInfo(response.error_code);
                    if (type === 'mobile') {
                        $scope.quickLoginCode.mobileBtnDisabled = false;
                    } else {
                        $scope.quickLoginCode.emailBtnDisabled = false;
                    }
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                });
            }
        };

        // 快捷登录按钮
        $scope.quickLoginBtn = {
            submitBtnText: i18n('loginSubmit'),
            disable: false,
            loginClick: function () {
                if (!$scope.quickAccountInput.value || !$scope.quickLoginCode.value || $scope.quickAccountInput.error || $scope.quickLoginCode.error) {
                    return;
                }
                var params = {
                    userId: $scope.quickLoginUsers.selectedUser.userid,
                    verifycode: $scope.quickLoginCode.value,
                    type: $scope.quickLoginModel.loginType,
                };
                iamHttpService.post({
                    url: '/authui/emergencyLogin',
                    params: params
                }).then(function (data) {
                    var data = typeof data === 'object' ? data : $.parseJSON(data);
                    if (data.loginResult === 'success') {
                        var redirectUrl;
                        var redirectUrlArr = data.redirectUrl.split('?');
                        if (/\/authui\/.*.html/.test(redirectUrlArr[0])) {
                            var hash = redirectUrlArr[0].replace('/authui/', '').replace('.html', '');
                            if (redirectUrlArr.length > 1) {
                                redirectUrl = '?' + redirectUrlArr[1] + '#/' + hash;
                            } else {
                                redirectUrl = '#/' + hash;
                            }
                        } else {
                            redirectUrl = data.redirectUrl;
                        }
                        window.location.href = redirectUrl;
                    } else {
                        if(data.error_code == 'IAM.1063'){
                            $scope.quickLoginCode.error = $scope.getErrorInfo(data.error_code);
                        }else{
                            $scope.quickAccountInput.error = $scope.getErrorInfo(data.error_code);
                        }
                    }
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                }, function (data) {
                    var response = typeof data.responseText === 'object' ? data.responseText : $.parseJSON(data.responseText);
                    if(response.error_code == 'IAM.1063'){
                        $scope.quickLoginCode.error = $scope.getErrorInfo(response.error_code);
                    }else{
                        $scope.quickAccountInput.error = $scope.getErrorInfo(response.error_code);
                    }
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                });
            }
        };

        $scope.quickLoginUsers = {
            btnId: 'selectUserBtnId',
            btnText: i18n('submitBtnTxt'),
            hasSelected: false,
            selectedUser: {},
            selectedUserTemp: {},
            options: [],
            hasDropdown: false,
            dropdownOpen: false, 
            back: function () {
                $scope.quickLoginUsers.selectedUserTemp = $scope.quickLoginUsers.selectedUser;
                $scope.quickLoginModel.showSelectStep = false;
            },
            select: function (option) {
                $scope.quickLoginUsers.selectedUserTemp = option;
            },
            dropdownSelect: function (option) {
                if ($scope.quickLoginUsers.selectedUser.userid !== option.userid) {
                    $scope.quickLoginUsers.selectedUser = option;
                    $scope.quickLoginUsers.selectedUserTemp = option;
                    $scope.quickAccountInput.value = $scope.quickLoginUsers.selectedUser.name;
                    $scope.quickLoginCode.error = '';
                    $scope.quickLoginUsers.dropdownOpen = false;
                }
            },
            H5DropdownSelect: function (option) { 
                $scope.quickLoginUsers.selectedUserTemp = option;
            },
            H5DropdownSubmit: function($event) {
                $scope.quickLoginUsers.selectedUser = $scope.quickLoginUsers.selectedUserTemp;
                $scope.quickAccountInput.value = $scope.quickLoginUsers.selectedUser.name;
                $scope.quickLoginCode.error = '';
                $scope.quickLoginUsers.dropdownOpen = false;
                $event.stopPropagation();
            },
            dropdownBtnClick: function () {
                $scope.quickLoginUsers.dropdownOpen = !$scope.quickLoginUsers.dropdownOpen;
            },
                
            closeDropdown: function () {
                $scope.quickLoginUsers.dropdownOpen = false;
            },
            btnClick: function () {
                $scope.quickLoginUsers.selectedUser = $scope.quickLoginUsers.selectedUserTemp;
                $scope.quickAccountInput.value = $scope.quickLoginUsers.selectedUser.name;
                $scope.quickLoginUsers.hasSelected = true;
                $scope.quickLoginModel.showSelectStep = false;
                $scope.quickLoginUsers.hasDropdown = $scope.quickLoginUsers.options.length > 1;
            },
            maskClick: function ($event) {
                $scope.quickLoginUsers.selectedUserTemp = $scope.quickLoginUsers.selectedUser;
                $scope.quickLoginUsers.dropdownOpen = false;
                $event.stopPropagation();
            },

        }

        //快捷登录end

        // 联合用户登录start
        $scope.idpAccountInput = {
            id: 'idpAccountInputId',
            value: '',
            oldValue: '',
            error: '',
            focused: false,
            ph: i18n('idpLogin.accountPh'),
            maxLength: 64,
            domainId: '',
            style: {
                height: iamUtils.layout.loginInputFieldHeight,
            },
            change: function () {
                $scope.idpAccountInput.oldValue = '';
                $scope.idpAccountInput.error = '';
                $scope.idpSelect.selectOptions = [];
                $scope.idpSelect.defaultOption = {
                    name: i18n('idpLogin.listPh')
                }
                $scope.idpSelect.disable = true;
            },
            blur: function () {
                if($scope.idpAccountInput.value === '' || $scope.idpAccountInput.value === $scope.idpAccountInput.oldValue)return;
                getIDPs($scope);
            },
        }

        // 手机号多用户下拉选择框
        $scope.idpSelect = {
            id: 'idpSelect',
            disable: true,
            selectOptions: [],
            preOption: {},
            defaultOption: {
                name: i18n('idpLogin.listPh')
            },
            showOptions: false,
            focus: function () {
                if($scope.idpSelect.disable) return;
                $scope.idpSelect.showOptions = true;
                if($scope.model.isMobile)$scope.idpSelect.preOption = $scope.idpSelect.defaultOption;
            },
            blur: function () {
                if (!$scope.model.isMobile) { $scope.idpSelect.showOptions = false; }
            },
            click: function () {
                if($scope.idpSelect.disable) return;
                $scope.idpSelect.showOptions = !$scope.idpSelect.showOptions;
                if($scope.model.isMobile)$scope.idpSelect.preOption = $scope.idpSelect.defaultOption;
            },
            maskClick: function ($event) {
                $scope.idpSelect.showOptions = false;
                if($scope.model.isMobile) $scope.idpSelect.defaultOption = $scope.idpSelect.preOption;
                $event.stopPropagation();
            },
            h5SubmitClick: function(){
                $scope.idpSelect.showOptions = false;
            },
            select: function (option) {
                setTimeout(function () {
                    $scope.idpSelect.defaultOption = option;
                    $scope.idpSelect.showOptions = $scope.model.isMobile;
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                }, 10)
            }
        };

        // 快捷登录按钮
        $scope.idpLoginBtn = {
            submitBtnText: i18n('idpLogin.goLogin'),
            disable: false,
            loginClick: function () {
                if(!$scope.idpAccountInput.value || $scope.idpAccountInput.error || $scope.idpSelect.disable)return;
                if ($scope.model.rememberChecked) {
                    var cookieObj = {
                        domainName: $scope.idpAccountInput.value,
                        selectedIdpId: $scope.idpSelect.defaultOption.id
                    }
                    cookieOp.addCookie('rememberChecked', 'true', cookieOp.DEFAULT_EXPIRES_TIME);
                    cookieOp.addCookie('enterprise_idp', JSON.stringify(cookieObj), cookieOp.DEFAULT_EXPIRES_TIME);
                } else {
                    cookieOp.delCookie('enterprise_idp');
                    cookieOp.delCookie('rememberChecked');
                }
                var url = 'https://auth.huaweicloud.com/authui/federation/websso?domain_id=' +
                        $scope.idpAccountInput.domainId + '&idp=' + $scope.idpSelect.defaultOption.id + '&protocol=' + $scope.idpSelect.defaultOption.protocol.toLowerCase();
                var service = iamUtils.getUrlParams()['service'];
                if (service) {
                    url += '&service=' + encodeURIComponent(service);
                } 
                window.location.href = url;
            }
        };
        // 联合用户登录end
            

        //悬浮在IAM账号用户名输入框时，显示tip
        $scope.bindIAMAccountTip = function () {
            var tip = i18n('iamAccountTip');
            if (iamUtils.CONFIG.helpCenterUrl) {
                var url = iamUtils.CONFIG.helpCenterUrl + i18n('iamAccountTipHelp');
                tip +=
                        iamUtils.i18nFormat('<a href=\'{0}\' target=\'_blank\'  tabindex=\'-1\'>{1}</a>', url, i18n('learnMore'));
            }
            $timeout(
                function () {
                    showTooltip($('#IAMAccountInputId'), tip);
                }
            );
        };

        $scope.bindIAMUsernameTip = function () {
            var tip = i18n('iamUsernameTip');
            if (iamUtils.CONFIG.helpCenterUrl) {
                var url = iamUtils.CONFIG.helpCenterUrl + i18n('iamUsernameTipHelp');
                tip +=
                        iamUtils.i18nFormat('<a href=\'{0}\' target=\'_blank\' tabindex=\'-1\'>{1}</a>', url, i18n('learnMore'));
            }
            $timeout(
                function () {
                    showTooltip($('#IAMUsernameInputId'), tip);
                }
            );
        };

        $scope.BiEvent = function () {
            try {
                var tempGa = $.extend([], arguments);
                tempGa[tempGa.length - 1] = 1;

                ga.apply(null, tempGa);
                var temp = $.extend([], arguments);
                send2CloudBISafe.apply(null, temp.slice(2));
            } catch (e) {
                console.dir(e)
            }
            return false;
        }

        $scope.goHwAccountLogin = function () {
            $scope.model.loginType = 'account';
            cookieOp.addCookie('last.login.type', 'account', cookieOp.DEFAULT_EXPIRES_TIME);
        }

        $scope.goIAMLogin = function () {
            send2CloudBI(iamUtils.pages.login, 'iamUserLogin.step1', '', 'operation_iam_iamUserLogin_step1');
            if ($scope.model.isLiteSDK) { //liteSDK拉起自己的IAM用户登录页面
                if (window.webLoader) {
                    window.webLoader.intoApp('iam_login');
                }
            } else {
                $scope.model.loginType = 'iam';
                cookieOp.addCookie('last.login.type', 'iam', cookieOp.DEFAULT_EXPIRES_TIME);
            }
        }

        $scope.goIDPLogin = function () {
            $scope.model.loginType = 'idp';
            cookieOp.addCookie('last.login.type', 'idp', cookieOp.DEFAULT_EXPIRES_TIME);
        }
        $scope.hwportalLogin = function () {
            var url = '';
            var service = iamUtils.getUrlParams()['service'];
            if (service) {
                url = '/authui/saml/login?xAccountType=hwportal&service=' + encodeURIComponent(service);
            } else {
                url = '/authui/saml/login?xAccountType=hwportal';
            }
            window.location.href = url;
        }
        $scope.eChannelLogin = function () {
            var url = '/authui/saml/login?xAccountType=eChannel';
            if ($scope.ipIsInternational) {
                url = iamUtils.CONFIG.hkUserCenterUrl ? '/authui/saml/login?xAccountType=eChannel&service=' + encodeURIComponent(iamUtils.CONFIG.hkUserCenterUrl + '/#/userindex/allview') : url;
            } else {
                url = iamUtils.CONFIG.userCenterUrl ? '/authui/saml/login?xAccountType=eChannel&service=' + encodeURIComponent(iamUtils.CONFIG.userCenterUrl + '/#/userindex/allview') : url;
            }
            window.location.href = url;
        }

        $scope.originalLogin = function () {
            if ($scope.model.isLiteSDK) { //liteSDK拉起自己的华为云帐号登录页面
                if (window.webLoader) {
                    window.webLoader.intoApp('account_login');
                }
                return;
            }
            var params = window.location.search;
            if (params) {
                params += '&quickLogin=true';
            } else {
                params = '?quickLogin=true';
            }
            var url = '/authui/login.html' + params;
            if (iamUtils.CONFIG.hasHwid === 'true') {
                url += '#/login2'
            } else {
                url += '#/login'
            }
            window.location.href = url;
        }


        $scope.goFpwd = function (send, event, button, click, login_fpwd) {
            var fpwdURI = getFpwdUrl($scope);
            $scope.BiEvent(send, event, button, click, login_fpwd, fpwdURI);
            window.location.href = fpwdURI;
        }

        var send2CloudBISafe = function() {
            try {
                send2CloudBI.apply(null, arguments);
            } catch (e) {
                console.dir(e)
            }
        }

        function preValidCallback() {
            $scope.IAMVerifyCode.checkCode = '';
            $scope.$apply();
            var verifyCodeImg = $('#inputVerifyCodeImg')[0];
            if (verifyCodeImg) {
                verifyCodeImg.src = '/authui/verifycode?index=1&alt=' + Math.random();
            }
        }

        if (!$scope.model.isLiteSDK) { //liteSDK不再需要IAM用户登录
            // 回车键自动登录
            $(document).keydown(function (event) {
                if (event.keyCode === 13) {
                    var id = $(document.activeElement).attr('id');
                    if (($scope.IAMVerifyCode.isNeedVerifyCode && id === 'checkCodeId') || id === 'IAMUsernameInputId' || id === 'IAMPasswordInputId' || id === 'IAMAccountInputId' || id === 'loginBtn') {
                        $scope.loginBtn.loginClick();
                        $scope.$apply();
                    }
                }
            });
            if (!$scope.model.isMobile) { createAdvScript($scope, send2CloudBISafe); }// 广告页
            initUserType($scope);
            loadRiskJs($scope.cbcRiskcheckAddress);
            setLoginBtn($scope);
        }
        
        window.onresize = function () {
            $scope.model.isMobile = window.outerWidth > 500 ? false : true;
            $scope.QRLoginModel.hasQRLogin = iamUtils.CONFIG.hasQrlogin && !$scope.model.isMobile && !$scope.model.isLiteSDK && $scope.model.language === 'zh-cn';
            if (!$scope.$$phase) {
                $scope.$apply();
            }
        }

        // 设置默认广告位图片
        $scope.defaultLoginAdv = function () {
            var pageImgSrc = '';
            let pageImgHref = '';
            if ($scope.ipIsInternational) {
                // 国际IP
                switch (window.language) {
                    case 'zh-cn':
                        pageImgSrc = require('custom/images/loginimg_intl_zh-cn.png');
                        pageImgHref = 'https://activity.huaweicloud.com/intl/zh-cn/free_packages/index.html';
                        break;
                    case 'en-us':
                        pageImgSrc = require('custom/images/loginimg_intl_en-us.png');
                        pageImgHref = 'https://activity.huaweicloud.com/intl/en-us/free_packages/index.html';
                        break;
                    default:
                        pageImgSrc = require('custom/images/loginimg_intl_zh-cn.png');
                        pageImgHref = 'https://activity.huaweicloud.com/intl/zh-cn/free_packages/index.html';
                        break;
                }
            } else {
                // 国内IP
                switch (window.language) {
                    case 'zh-cn':
                        pageImgSrc = require('custom/images/loginimg_zh-cn.png');
                        pageImgHref = 'https://www.huaweicloud.com/mobile_app/hwapp.html';
                        break;
                    case 'en-us':
                        pageImgSrc = require('custom/images/loginimg_en-us.png');
                        pageImgHref = 'https://activity.huaweicloud.com/intl/en-us/free_packages/index.html';
                        break;
                    default:
			                pageImgSrc = require('custom/images/loginimg_zh-cn.png');
                        pageImgHref = 'https://www.huaweicloud.com/mobile_app/hwapp.html';
                        break;
                }
            }
            document.getElementById('loginAdv').innerHTML = '<a href=\'' + pageImgHref + '\' target=\'_blank\' rel=\'noopener noreferrer\'><img id=\'loginAdImgDefault\' style=\'display:none\' src=\'' + pageImgSrc + '\'></a>';
            setTimeout(function () {
                if ($('#loginAdImgDefault')) {
                    $('#loginAdImgDefault').show();
                }
            }, 1000);
        }
        $scope.defaultLoginAdv();
    };

    function onSubmitBtnClick($scope) {
        // 校验不通过 不可提交
        if ($scope.loginBtn.disable) {
            return;
        }
        send2CloudBI(iamUtils.pages.login, 'iamUserLogin.step2', '', 'operation_iam_iamUserLogin_step2');
        disabledLoginBtn($scope); //登录按钮置灰
        hideErrorMsg($scope);
        // recordLoginType($scope); // 记录登录方式到cookie
        cookieOp.delCookie('enterprise_idp');
        recordUserType($scope.model.loginType === 'iam'); // 记录 accountType，与更换手机号等页面兼容: BUG2019111401458
        var countryCode = $scope.model.defaultCode;
        if (countryCode === undefined) {
            countryCode = '';
        }
        var checkCode = $scope.IAMVerifyCode.isNeedVerifyCode ? $('#' + $scope.IAMVerifyCode.checkCodeId).val() : '';
        var passwd = $scope.IAMPasswordInput.value;
        if ($scope.IAMAccountInput.value === 'op_service') {
            $scope.IAMAccountInput.value = '';
            $scope.IAMUsernameInput.value = '';
            $scope.IAMPasswordInput.value = '';
            showErrAndRefCode($scope, 'domainWrong');
            return;
        }
        if (isValUnvalid($scope.IAMAccountInput.value)) {
            showErrAndRefCode($scope, 'accountNameBlank');
            return;
        }
        if (isValUnvalid($scope.IAMUsernameInput.value)) {
            showErrAndRefCode($scope, 'userNameBlank');
            return;
        }
        if (isValUnvalid(passwd)) {
            showErrAndRefCode($scope, 'pwdBlank');
            return;
        }
        if ($scope.IAMVerifyCode.isNeedVerifyCode && (isValUnvalid(checkCode) || checkCode.length > 4)) {
            showErrAndRefCode($scope, 'checkCodeBlank');
            return;
        }
        if (passwd.length > $scope.securityPolicy.passwordpolicy.password_maxlen) {
            $scope.IAMPasswordInput.value = '';
            showErrAndRefCode($scope, 'domainWrong');
            return;
        }

        var loginPostParams = {
            'userpasswordcredentials.domain': encodeURIComponent($scope.IAMAccountInput.value),
            'userpasswordcredentials.domainType': 'name',
            'userpasswordcredentials.username': encodeURIComponent($scope.IAMUsernameInput.value),
            'userpasswordcredentials.countryCode': countryCode,
            'userpasswordcredentials.verifycode': checkCode,
            'userpasswordcredentials.password': encodeURIComponent(passwd),
            'userpasswordcredentials.companyLogin': true,
            'userpasswordcredentials.userInfoType': getUserNameType($scope.IAMUsernameInput.value),
            'userpasswordcredentials.riskMonitorJson': JSON.stringify({
                'devID': get_Cookie('cbc-sid'),
                'hwMeta': document.getElementById('cbc-hwmeta') ? document.getElementById('cbc-hwmeta').value : ''
            }),
            __checkbox_warnCheck: 'true',
            'isAjax': 'true',
            Submit: 'Login'
        }
        doLogin('/authui/validateUser.action' + filterSearch(), loginPostParams);

        function doLogin(URL, PARAMS) {
            iamHttpService.post({
                url: URL,
                params: PARAMS
            }).then(function (data) {
                data = typeof data === 'object' ? data : $.parseJSON(data);
                if (data.loginResult === 'success') {
                    recordLoginCookie($scope, countryCode, 'forLogin');// 登录成功后记录cookie
                    send2CloudBI(iamUtils.pages.login, 'iamUserLogin.success', '', 'operation_iam_iamUserLogin_success');
                    var redirectUrl;
                    var redirectUrlArr = data.redirectUrl.split('?');
                    if (/\/authui\/.*.html/.test(redirectUrlArr[0])) {
                        var hash = redirectUrlArr[0].replace('/authui/', '').replace('.html', '');
                        if (redirectUrlArr.length > 1) {
                            redirectUrl = '?' + redirectUrlArr[1] + '#/' + hash;
                        } else {
                            redirectUrl = '#/' + hash;
                        }
                    } else {
                        redirectUrl = data.redirectUrl;
                    }
                    window.location.href = redirectUrl;
                } else if (data.loginResult === 'failed') {
                    recordLoginCookie($scope, countryCode, 'forFindPwd');// 登录失败时 记录当前的帐号cookie 方便用户点击忘记密码时 回填在页面
                    if (data.authFailed === true) {
                        loginVerify($scope);
                    }
                    $scope.IAMPasswordInput.value = '';
                    showErrAndRefCode($scope, data.errorCode);
                    if(window.cbchwcap && window.cbchwcap.reload){
                        window.cbchwcap.reload()
                    }
                } else {
                    $scope.IAMPasswordInput.value = '';
                    showErrAndRefCode($scope, '417');
                    if(window.cbchwcap && window.cbchwcap.reload){
                        window.cbchwcap.reload()
                    }
                }
            }, function () {
                $scope.IAMPasswordInput.value = '';
                showErrAndRefCode($scope, '417');
                if(window.cbchwcap && window.cbchwcap.reload){
                    window.cbchwcap.reload()
                }
            });
        }

    }

    function filterSearch() {
        var newSearch = '';
        var searchStr = window.location.search.substring(1);
        var params = searchStr.split('&');
        for (var index = 0; index < params.length; index++) {
            if (params[index].indexOf('=') !== -1) {
                var key = params[index].substring(0, params[index].indexOf('='));
                if (key === 'service') {
                    var service = params[index];
                    if (service.indexOf('hwclouds') !== -1) {
                        service = service.replace(/hwclouds/g, 'huaweicloud');
                    }
                    newSearch = newSearch + '&' + service
                } else if ((key !== 'step')) {
                    newSearch = newSearch + '&' + params[index];
                }
            }
        }
        return newSearch === '' ? '' : '?' + newSearch.substring(1);
    }

    function get_Cookie(e) {
        var n, t = '', r = document['getElementById']('JSdev');
        if (r && !t)
            try {
                n = r.getsid() || '',
                t = n
            } catch (o) { }
        try {
            window['localStorage'] && !t && (n = localStorage[e] || '',
            t = n)
        } catch (o) { }
        if (window['navigator']['cookieEnabled'] && !t) {
            var i = document['cookie']['indexOf'](e + '=');
            if (-1 != i) {
                i += e.length + 1;
                var a = document['cookie']['indexOf'](';', i);
                -1 == a && (a = document['cookie']['length']),
                n = decodeURIComponent(document['cookie']['substring'](i, a)) || '',
                t = n
            }
        }

        return t;
    }

    // 检查登录使用的帐号是否需要填写图形验证码
    function loginVerify($scope) {
        if (!$scope.IAMAccountInput.value || !$scope.IAMUsernameInput.value) {
            $scope.IAMVerifyCode.isNeedVerifyCode = false;
            return;
        }
        var params;
        var IAMUsername = $scope.IAMUsernameInput.value.trim();
        var type = getUserNameType(IAMUsername);
        if (type === 'mobile') {
            var countryCode = $scope.model.defaultCode; 
            IAMUsername = countryCode + '-' + IAMUsername;
        };
        params = {
            userName: IAMUsername,
            userType: type,
            accountName: $scope.IAMAccountInput.value ? encodeURIComponent($scope.IAMAccountInput.value) : ''
        };
        iamHttpService.post({
            url: '/authui/login/verify',
            params: params
        }).then(function (data) {
            $scope.IAMVerifyCode.isNeedVerifyCode = data.needVerify;
            $scope.$apply();
        }, function () {
            $scope.IAMVerifyCode.isNeedVerifyCode = true;
            $scope.$apply();
        });
    }

    // 展示错误信息，刷新图形验证码，恢复登录按钮
    function showErrAndRefCode($scope, errorScene) {
        showErrorMsg($scope, errorScene);
        refreshVerifyCode($scope);
        restoreLoginBtn($scope);
    }

    function createAdvScript($scope, send2CloudBISafe) {
        var loginAdv = document.getElementById('loginAdv');
        if (iamUtils.isShowByStyleOfSite() && loginAdv) {
            $('#loginAdv').empty();
            $('#loginAdv').append('<img id=\'loginlogo\'  />');
            $('#loginlogo').attr('src', getLogoOfRussia());
            return;
        }
        var pos = iamUtils.getUrlParams()['pos'];
        if (pos === '' || pos === undefined) {
            pos = 'login';
        }
        var oScript = document.createElement('script');
        oScript.type = 'text/javascript';
        var getAdApi = 'https://portal.huaweicloud.com/rest/cbc/portalapppublishservice/v1/ad/disp';
        var pos = '';
        var comp = '';
        if (loginAdv) {
            if ($scope.ipIsInternational) {
                // 国际IP
                switch (window.language) {
                    case 'zh-cn':
                        pos = 'www.huaweicloud.com/ad/login_board_en-zh.html';
                        comp = 'pep-ad-img_1620800848076';
                        break;
                    case 'en-us':
                        pos = 'www.huaweicloud.com/ad/login_board_en-us.html';
                        comp = 'pep-ad-img_1620800987830';
                        break;
                    default:
                        pos = 'www.huaweicloud.com/ad/login_board_en-us.html';
                        comp = 'pep-ad-img_1620800987830';
                        break;
                }
            } else {
                // 国内IP
                switch (window.language) {
                    case 'zh-cn':
                        pos = 'www.huaweicloud.com/ad/login_board.html';
                        comp = 'pep-ad-img_1619667657367';
                        break;
                    case 'en-us':
                        pos = 'www.huaweicloud.com/ad/login_board_ch-us.html';
                        comp = 'pep-ad-img_1620800651862';
                        break;
                    default:
                        pos = 'www.huaweicloud.com/ad/login_board_ch-us.html';
                        comp = 'pep-ad-img_1620800651862';
                        break;
                }
            }
            oScript.src = getAdApi + '?pos=' + pos + '&comp=' + comp + '&containerId=loginAdv&st=' + Math.random();
            loginAdv.appendChild(oScript);
        }
    }

    function initUserType($scope) {
        var idUrl = iamUtils.getUrlParams()['id'];
        // 根据url中是否带有id参数区分是否使用了 IAM用户登录链接
        if (idUrl === undefined) {
            // 上次登录的情形会被cookie last.login.type记录 默认区分 个人帐号和IAM用户登录方式
            if (cookieOp.getCookie('last.login.type') && cookieOp.getCookie('last.login.type') === 'iam') {
                $scope.model.loginType = 'iam';
                initIAMInput($scope);
                send2CloudBI(iamUtils.pages.login, 'iamUserLogin.step1', '', 'operation_iam_iamUserLogin_step1');
            } else if(cookieOp.getCookie('last.login.type') && cookieOp.getCookie('last.login.type') === 'idp'){
                $scope.model.loginType = 'idp';
            } else {
                $scope.model.loginType = 'account';
            }
        } else {
            $scope.model.loginType = 'iam';
            $scope.IAMAccountInput.value = encodeURIComponent(idUrl);
            $scope.IAMAccountInput.disable = true
            $scope.IAMUsernameInput.value = '';
            $scope.IAMUsernameInput.getFocus();
            $scope.IAMPasswordInput.value = '';
            // 不记住登录名
            $scope.model.rememberChecked = false;
        }

        // 初始化企业联邦登录表单
        if(cookieOp.getCookie('rememberChecked') === 'true'){
            $scope.model.rememberChecked = true;
            try{
                var cookieObj = JSON.parse(cookieOp.getCookie('enterprise_idp'));
                if(cookieObj){
                    $scope.idpAccountInput.value = cookieObj.domainName;
                    getIDPs($scope, cookieObj.selectedIdpId);
                }
            }catch(err){}
        } 
                    
        if (!$scope.$$phase) {
            $scope.$apply();
        }
        return;
    }

    function isLogin($scope) {
        $.ajax({
            'type': 'GET',
            'contentType': 'application/x-www-form-urlencoded; charset=UTF-8',
            'url': '/authui/isLogin',
            'async': true,
            'success': function (data) {
                data = typeof data === 'object' ? data : $.parseJSON(data);
                if (data.result === 'islogin' && data.code === 201 && data.status === 'success') {
                    // 说明已经有会话登录 重定向一次
                    window.location.href = '/authui/' + window.location.search;
                }
                if(data.code === 403){
                    $scope.quickLoginModel.hasQuickLogin = true;
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                }
            },
            'error': function () {
                showErrorMsg($scope, '417');
                setTimeout(function () {
                    hideErrorMsg($scope);
                }, 10000);
            }
        });
    }

    function disabledLoginBtn($scope) {
        var loginBtn = $('#loginBtn');
        var btnText = loginBtn.children()[0];
        $(btnText).html(i18n('logining'));
        $scope.loginBtn.disable = true;
    }

    function restoreLoginBtn($scope) {
        var loginBtn = $('#loginBtn');
        var btnText = loginBtn.children()[0];
        $(btnText).html(i18n('loginSubmit'));
        setLoginBtn($scope);
    }

    // 设置登录按钮的状态
    function setLoginBtn($scope) {
        if (!$scope.IAMAccountInput.value || !$scope.IAMUsernameInput.value || !$scope.IAMPasswordInput.value) {
            $scope.loginBtn.disable = true;
            return;
        }
        if ($scope.IAMVerifyCode.isNeedVerifyCode && !$scope.IAMVerifyCode.checkCode) {
            $scope.loginBtn.disable = true;
            return;
        }
        if ($scope.IAMLoginErrorMsg.show) {
            $scope.loginBtn.disable = true;
            return;
        }
        $scope.loginBtn.disable = false;
        return;
    }

    function refreshVerifyCode($scope) {
        if ($scope.IAMVerifyCode.isNeedVerifyCode) {
            $scope.IAMVerifyCode.getVerifyCode();
        }
    }

    function getUserNameType(userName) {
        var emailPattern = iamUtils.EmailRegex;
        var phonePattern = /^[0-9]\d*$/;
        if (emailPattern.test(userName)) {
            return 'email';
        } else if (phonePattern.test(userName)) {
            return 'mobile';
        } else {
            return 'name';
        }
    };

    function showErrorMsg($scope, errorCode) {
        if (errorCode && $scope.domainErrorMsgObj[errorCode]) {
            // 帐号名输入框报错
            $scope.IAMLoginErrorMsg.content = $scope.domainErrorMsgObj[errorCode];
            // $scope.IAMLoginErrorMsg.domainError = true;
        } else if (errorCode && $scope.usernameErrorMsgObj[errorCode]) {
            // IAM用户名输入框报错
            $scope.IAMLoginErrorMsg.content = $scope.usernameErrorMsgObj[errorCode];
            // $scope.IAMLoginErrorMsg.usernameError = true;
        } else if (errorCode && $scope.pwdErrorMsgObj[errorCode]) {
            // 密码输入框报错
            $scope.IAMLoginErrorMsg.content = $scope.pwdErrorMsgObj[errorCode];
            // $scope.IAMLoginErrorMsg.pwdError = true;
        } else if (errorCode && $scope.nameOrPwdErrorMsgObj[errorCode]) {
            // IAM用户名及密码输入框报错
            $scope.IAMLoginErrorMsg.content = $scope.nameOrPwdErrorMsgObj[errorCode];
            // $scope.IAMLoginErrorMsg.nameOrPwdError = true;
        } else if (errorCode && $scope.verifycodeErrorMsgObj[errorCode]) {
            // 图形验证码输入框报错
            $scope.IAMLoginErrorMsg.content = $scope.verifycodeErrorMsgObj[errorCode];
            // $scope.IAMLoginErrorMsg.verifycodeError = true;
        } else if (errorCode && $scope.errorMsgObj[errorCode]) {
            // 其他系统报错
            $scope.IAMLoginErrorMsg.content = $scope.errorMsgObj[errorCode];
            // $scope.IAMLoginErrorMsg.show = true;
        } else if (errorCode) {
            if (errorCode == i18n('isRuUser')) {
                $scope.IAMLoginErrorMsg.content = i18n('isRuUser1');
                $scope.IAMLoginErrorMsg.goLoginShow = true;
                $scope.IAMLoginErrorMsg.goLoginHref = 'https://' + 'auth-intl.huaweicloud.com' + '/authui/?locale=' + window.language;
                $scope.IAMLoginErrorMsg.goLoginContent = i18n('goLogin.ru');
            } else if(errorCode == 416){
                $scope.IAMLoginErrorMsg.content = i18n('clientIpInvalid');
                $scope.IAMLoginErrorMsg.goLoginShow = true;
                $scope.IAMLoginErrorMsg.goLoginHref = iamUtils.CONFIG.helpCenterUrl +  i18n('clientIpInvalid.helpUrl');
                $scope.IAMLoginErrorMsg.goLoginContent = i18n('clientIpInvalid.learnMore');
            }else{
                $scope.IAMLoginErrorMsg.content = errorCode;
            }
            // $scope.IAMLoginErrorMsg.show = true;
        }

        $scope.IAMLoginErrorMsg.content = $scope.$sce.trustAsHtml($scope.IAMLoginErrorMsg.content);
        
        $scope.IAMLoginErrorMsg.show = true;
        if (!$scope.$$phase) {
            $scope.$apply();
        }
    }

    function hideErrorMsg($scope) {
        $scope.IAMLoginErrorMsg.show = false;
        $scope.IAMLoginErrorMsg.goLoginShow = false;
        $scope.IAMLoginErrorMsg.domainError = false;
        $scope.IAMLoginErrorMsg.usernameError = false;
        $scope.IAMLoginErrorMsg.pwdError = false;
        $scope.IAMLoginErrorMsg.nameOrPwdError = false;
        $scope.IAMLoginErrorMsg.verifycodeError = false;
        if (!$scope.$$phase) {
            $scope.$apply();
        }
    }

    function isValUnvalid(value) {
        return (value === '' || value === undefined);
    }

    function showTooltip(ele, content) {

        var tipHtml = '<div class="iam-name-tooltip" \
                                style="display: block;" tabindex="-1"> \
                                <div class="iam-ti-tooltip-content"  \
                                style="overflow-y: auto; padding: 1px; white-space: normal;"> \
                                TIP_CONTENT</div></div>'
            .replace('TIP_CONTENT', content)

        var tip;
        var isShown = false;

        var addTip = function () {
            tip = $(tipHtml);
            tip.css('left', 0);
            tip.css('width', ele.outerWidth());
            ele.parent().append(tip);
            tip.css('top', ele.outerHeight());
            tip.mouseleave(
                function () {
                    tip && tip.remove();
                }
            )
            isShown = true;
        }

        ele.mouseenter(
            function () {
                //光标进入元素区域，显示tip
                setTimeout(
                    function () {
                        if (ele.is(':hover') && !isShown && !ele.val()) {
                            addTip();
                        }
                    }, 500
                )
            }
        ).mouseleave(
            function () {
                //若光标移动到tip上，不自动消失
                setTimeout(
                    function () {
                        if (!tip.is(':hover')) {
                            isShown = false;
                            tip && tip.remove();
                        }
                    }
                    , 300
                )
            }
        ).on('keyup', function (e) {
            //回车后移除tip
            setTimeout(function(){
                if (e.which == 13 || ele.val()) {
                    isShown = false;
                    tip && tip.remove();
                }else if(ele.is(':hover') && !isShown){
                    addTip();
                }
            });
        }).click(
            //兼容移动端触摸场景
            function () {
                if (ele.is(':hover') && !isShown && !ele.val()) {
                    addTip();
                }
            }
        ).blur(
            function () {
                tip && !tip.is(':hover') && tip.remove();
                isShown = false;
            }
        );
    }

    function recordUserType(isCompany) {
        var value = isCompany ? 'company' : 'personal';
        cookieOp.addCookie('accountType', value, cookieOp.DEFAULT_EXPIRES_TIME);
    }

    function recordLoginCookie($scope, countryCode, type) {
        // 登录方式的cookie
        cookieOp.delCookie('loginType');
        // 记住登录名的cookie
        cookieOp.delCookie('rememberChecked');
        // 帐号登录方式时主帐号
        cookieOp.delCookie('personalAccount');
        // IAM登录方式 主帐号
        cookieOp.delCookie('IAMAccount');
        // IAM登录方式 子用户
        cookieOp.delCookie('IAMUsername');
        // IAM登录方式 子用户是手机时
        cookieOp.delCookie('countryCode');
        cookieOp.delCookie('mobile');
        if (type === 'forFindPwd') {
            // 登录失败时 为找回密码页面记录cookie
            if ($scope.model.loginType === 'iam') {
                cookieOp.addCookie('loginType', 'company', cookieOp.DEFAULT_EXPIRES_TIME);
                cookieOp.addCookie('IAMAccount', $scope.IAMAccountInput.value.trim(), cookieOp.DEFAULT_EXPIRES_TIME);
                cookieOp.addCookie('IAMUsername', $scope.IAMUsernameInput.value.trim(), cookieOp.DEFAULT_EXPIRES_TIME);
            }
        } else if(type === 'forLogin'){
            // 登录之后清除标记了找回密码方式的cookie
            cookieOp.delCookie('findPwdEnd');
            if ($scope.model.rememberChecked && $scope.model.loginType === 'iam') {
                // IAM用户登录方式
                cookieOp.addCookie('IAMAccount', $scope.IAMAccountInput.value.trim(), cookieOp.DEFAULT_EXPIRES_TIME);
                cookieOp.addCookie('IAMUsername', $scope.IAMUsernameInput.value.trim(), cookieOp.DEFAULT_EXPIRES_TIME);
                cookieOp.addCookie('rememberChecked', true, cookieOp.DEFAULT_EXPIRES_TIME);
            }
        }
    }

    function getFpwdUrl($scope) {
        var serviceParam = '';
        var service = iamUtils.getUrlParams()['service'];
        if (service) {
            serviceParam = '&service=' + encodeURIComponent(service);
        }
        return '/authui/login.html?locale=' + window.language + '&UserType=' + ($scope.model.loginType === 'iam' ? 'e' : 'p') + serviceParam + '#/fpwd';
    }

    // 调用authui/getSDKBaseInfo接口获取js-sdk的url及配置信息
    function getSDKBaseInfo($scope) {
        var params = {
            flowType: 'unionLogin'
        }
        if (utils.getUrlParams().service) {
            params.service = utils.getUrlParams().service;
        }
        iamHttpService.get({
            url: '/authui/getSDKBaseInfo',
            params: params,
        }).then(function (data) {
            data = typeof data === 'object' ? data : $.parseJSON(data);
            if (data.isSuccess === 1) {
                data.businessConfig = typeof data.businessConfig === 'object' ? data.businessConfig : $.parseJSON(data.businessConfig);
                var baseConfig = {
                    'isSuccess': '1',
                    'pageTokenKey': data.pageTokenKey,
                    'pageToken': data.pageToken,
                    'jsSdkUrl': data.jsSdkUrl,
                    'hwidConfig': data.hwidConfig
                };
                $scope.model.privacyLink = data.businessConfig.unifiedIDPrivacyUrl;//隐私链接
                baseConfig.businessConf = {
                    flowType: 'unionLogin', //使用场景unionLogin
                    clientType: $scope.model.isMobile || $scope.model.isLiteSDK ? 'mobileWap' : 'pcWeb', //手机还是pc
                    showType: 'page', // 展示方式
                    loginCallback: function () {
                        postRiskData();
                        recordUserType($scope.model.loginType === 'iam');
                    },
                    mountedCallback: function () {
                        $scope.model.sdkLoading = false;
                        if (!$scope.$$phase) {
                            $scope.$apply();
                        }
                    }
                }
                delete window.hwidSDK;//避免对二次渲染产生影响
                loadJsSDK($scope, baseConfig);
            } else {
                $scope.model.sdkLoading = false;
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            }
        }, function () {
            $scope.model.sdkLoading = false;
        })
    }

    // 获取js-sdk并渲染登录框
    function loadJsSDK($scope, baseConfig) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        if (script.readyState) { // IE
            script.onreadystatechange = function () {
                if (script.readyState === 'loaded' || script.readyState === 'complete') {
                    try{
                        script.onreadystatechange = null;
                        hwidSDK.init(baseConfig);
                    }catch(e){
                        $scope.model.sdkLoading = false;
                    }
                }
            }
        } else { // 其他浏览器
            script.onload = function () {
                try{
                    hwidSDK.init(baseConfig);
                }catch(e){
                    $scope.model.sdkLoading = false;
                }
            };
            script.onerror = function () {
                $scope.model.sdkLoading = false;
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            }
        }
        script.src = baseConfig.jsSdkUrl;
        document.getElementsByTagName('head')[0].appendChild(script);
    }

    //加载cbc风控组件
    function loadRiskJs(url) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        document.getElementsByTagName('head')[0].appendChild(script);
    }

    // 传递风控数据
    function postRiskData() {
        var params = {
            'devID': get_Cookie('cbc-sid'),
            'hwMeta': document.getElementById('cbc-hwmeta') ? document.getElementById('cbc-hwmeta').value : ''
        };
        iamHttpService.post({
            url: '/authui/riskData',
            params: params,
        }).then(function (data) {
            // 不管成功还是失败不做任何操作，不阻塞后面的进程               
        }, function () {
            // 不管成功还是失败不做任何操作，不阻塞后面的进程
        })
    }

    // 获取下载APP链接
    function getDownloadUrl(){
        return 'https://www.huaweicloud.com/mobile_app/hwapp.html';
    }

    // 获取登录凭证并生成二维码
    function QRCodeInit($scope, $timeout, $interval, iamUtils, send2CloudBISafe){
        $scope.QRLoginModel.QRLoginTitle = i18n('QRLogin.title1');
        $scope.QRLoginModel.QRCodeStatus = 'new';
        $scope.QRLoginModel.QRCodeInvalid = false;
        iamHttpService.get({
            url: '/authui/qrcode',
            cache: false,
            params: {}
        }).then(function (data) {
            data = typeof data === 'object' ? data : $.parseJSON(data);
            $scope.QRLoginModel.clientKey = data.client_key;
            $timeout(function () {
                var loginQRCodeDiv = document.querySelector('#loginQRCodeDiv');
                loginQRCodeDiv.innerHTML = '';
                QRCode.toCanvas(loginQRCodeDiv, data.qrcode_content, {
                    margin: 0,
                    width: 260
                })
            }, 0);
            countDown($scope, $interval, iamUtils);
            pollingCodeStatus($scope, $interval, iamUtils, send2CloudBISafe);
        }, function () {
            // 异常情况
            $scope.QRLoginModel.QRCodeInvalid = true;
            $scope.$apply();
        })   
    } 

    // 二维码失效时间倒计时
    function countDown($scope, $interval, iamUtils) {
        var count = 0;
        $scope.QRLoginModel.remainingTime = iamUtils.i18nFormat(i18n('QRLogin.remainingTime'), QRCODE_VALID_TIME - count);
        $interval.cancel($scope.QRLoginModel.countDownInterval);
        $scope.QRLoginModel.countDownInterval = $interval(function () {
            count++;
            if (count < QRCODE_VALID_TIME) {
                $scope.QRLoginModel.remainingTime = iamUtils.i18nFormat(i18n('QRLogin.remainingTime'), QRCODE_VALID_TIME - count);
            } else {
                $scope.QRLoginModel.QRCodeInvalid = true;
                $interval.cancel($scope.QRLoginModel.countDownInterval);
                $interval.cancel($scope.QRLoginModel.pollingInterval);
            }
        }, 1000);
    }

    // 轮询登录状态 
    function pollingCodeStatus($scope, $interval, iamUtils, send2CloudBISafe) {
        var params = {};
        params.client_key = $scope.QRLoginModel.clientKey;
        var service = iamUtils.getUrlParams()['service'];
        if (service) {
            params.redirect_url = service;
        }
        $interval.cancel($scope.QRLoginModel.pollingInterval);
        $scope.QRLoginModel.pollingInterval = $interval(function () {
            iamHttpService.get({
                url: '/authui/qrcode/status',
                cache: false,
                params: params,
            }).then(function (data) {
                data = typeof data === 'object' ? data : $.parseJSON(data);
                if(data.error_code && data.error_code == '427'){
                    window.location.href = '/authui/' + window.location.search;
                }else if (data.status == 'authorizing') {
                    send2CloudBISafe(iamUtils.pages.login, 'click_scanQRCode');
                    $scope.QRLoginModel.QRCodeStatus = 'authorizing';
                    $scope.QRLoginModel.QRLoginTitle = i18n('QRLogin.title2');
                    $interval.cancel($scope.QRLoginModel.countDownInterval);
                }else if(data.status == 'refused' || data.status == 'expired'){
                    $scope.QRLoginModel.QRCodeStatus = 'refused';
                    $scope.QRLoginModel.QRLoginTitle = i18n('QRLogin.title2');
                    $interval.cancel($scope.QRLoginModel.pollingInterval);
                }else if(data.status == 'authorized'){
                    window.location.href = data.redirect_url;
                    $interval.cancel($scope.QRLoginModel.pollingInterval);
                }
            }, function(){});
        }, 3000);
    }

    function getRegistUrl($scope) {
        var service_url = iamUtils.getUrlParams()['service'] ;
        var registUrl = $scope.ipIsInternational? iamUtils.CONFIG.cbcRegUrlIntl : iamUtils.CONFIG.cbcRegUrl;
        registUrl += '&hwid=login';
        registUrl += service_url ? '&service=' + encodeURIComponent(service_url) : '';
        return registUrl;
    }

    //根据输入获取用户列表
    function getUserList($scope, type) {
        var params = {
            type: type,
            value: $scope.quickAccountInput.value,
        };
        iamHttpService.post({
            url: '/authui/checkexist',
            params: params
        }).then(function (data) {
            var data = typeof data === 'object' ? data : $.parseJSON(data);
            if (data.result === 'success') {
                // 记录旧值 防止多次请求
                $scope.quickAccountInput.oldValue = $scope.quickAccountInput.value;
                if(data.count == 0){
                    $scope.quickAccountInput.error = i18n('fpwd.EnterCorrectEnterpriseAccount');
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                    return;
                }
                //过滤出已绑定了手机或邮箱的账号
                $scope.quickLoginUsers.options = [];
                for(var i=0;i<data.users.length;i++){
                    if(data.users[i].mobile || data.users[i].email){
                        $scope.quickLoginUsers.options.push(data.users[i]);
                    }
                }
                if($scope.quickLoginUsers.options.length > 1){
                    $scope.quickLoginUsers.selectedUser = $scope.quickLoginUsers.options[0];
                    $scope.quickLoginUsers.selectedUserTemp = $scope.quickLoginUsers.selectedUser;
                    $scope.quickLoginUsers.btnClick();
                    //只有输入手机的情况才需要到选择用户页面
                    if(params.type === 'mobile'){
                        if($scope.model.isMobile){
                            $scope.quickLoginUsers.dropdownOpen = true;
                        }else{
                            $scope.quickLoginModel.showSelectStep = true;
                        }
                    }
                } else if ($scope.quickLoginUsers.options.length == 1) {
                    $scope.quickLoginUsers.selectedUser = $scope.quickLoginUsers.options[0];
                } else {
                    $scope.quickAccountInput.error = i18n('quickLogin.notAllowed');
                }
                if ($scope.quickLoginUsers.options.length > 0) {
                    $scope.quickLoginCode.mobileBtnDisabled = false;
                    $scope.quickLoginCode.emailBtnDisabled = false;
                    setQuickLoginType($scope, type);
                }
            } else {
                // 请求返回错误
                $scope.quickAccountInput.error = i18n('systemException');
            }
            if (!$scope.$$phase) {
                $scope.$apply();
            }
        }, function () {
            $scope.quickAccountInput.error = i18n('systemException');
            if (!$scope.$$phase) {
                $scope.$apply();
            }
        });
    }

    //根据用户切换验证方式
    function setQuickLoginType($scope, type) {
        if(type === 'name'){
            if ($scope.quickLoginUsers.selectedUser.mobile) {
                $scope.quickLoginModel.loginTypeChange('mobile');
            } else {
                $scope.quickLoginModel.loginTypeChange('email');
            }
        }else{
            if (type === 'mobile' && $scope.quickLoginModel.loginType === 'email') {
                $scope.quickLoginModel.loginTypeChange('mobile');
            } else if (type === 'email' && $scope.quickLoginModel.loginType === 'mobile') {
                $scope.quickLoginModel.loginTypeChange('email');
            }
        }
            
    }

    //快捷登录验证码倒计时
    function quickLoginCountDown($scope, $interval, iamUtils) {
        var type = $scope.quickLoginModel.loginType;
        if (type === 'email') {
            var count = 0;
            $scope.quickLoginCode.emailBtnTxt = iamUtils.i18nFormat(i18n('quickLogin.codeCountdown'), 60 - count);
            $scope.quickLoginCode.emailBtnDisabled = true;
            $interval.cancel($scope.quickLoginCode.emailInterval);
            $scope.quickLoginCode.emailInterval = $interval(function () {
                count++;
                if (count < 60) {
                    $scope.quickLoginCode.emailBtnTxt = iamUtils.i18nFormat(i18n('quickLogin.codeCountdown'), 60 - count);
                } else {
                    $scope.quickLoginCode.emailBtnDisabled = false;
                    $scope.quickLoginCode.emailBtnTxt = i18n('quickLogin.codeBtn');
                }
            }, 1000);
        } else {
            var count = 0;
            $scope.quickLoginCode.mobileBtnTxt = iamUtils.i18nFormat(i18n('quickLogin.codeCountdown'), 60 - count);
            $scope.quickLoginCode.mobileBtnDisabled = true;
            $interval.cancel($scope.quickLoginCode.mobileInterval);
            $scope.quickLoginCode.mobileInterval = $interval(function () {
                count++;
                if (count < 60) {
                    $scope.quickLoginCode.mobileBtnTxt = iamUtils.i18nFormat(i18n('quickLogin.codeCountdown'), 60 - count);
                } else {
                    $scope.quickLoginCode.mobileBtnDisabled = false;
                    $scope.quickLoginCode.mobileBtnTxt = i18n('quickLogin.codeBtn');
                }
            }, 1000);
        }
    }

    //通过domainName获取idp列表
    function getIDPs($scope, defaultSelectId){
        iamHttpService.post({
            url: '/authui/identityProviders',
            params: {
                domain_name: encodeURIComponent($scope.idpAccountInput.value)
            }
        }).then(function (data) {
            data = typeof data === 'object' ? data: JSON.parse(data); 
            $scope.idpSelect.selectOptions = [];
            $scope.idpAccountInput.domainId = data.domain_id;
            $scope.idpAccountInput.oldValue = $scope.idpAccountInput.value;
            for(var i=0;i<data.identity_providers.length;i++){
                $scope.idpSelect.selectOptions.push({
                    name: data.identity_providers[i].id, 
                    id: data.identity_providers[i].id,
                    protocol: data.identity_providers[i].protocol,
                });
                if(data.identity_providers[i].id === defaultSelectId){
                    $scope.idpSelect.defaultOption = $scope.idpSelect.selectOptions[$scope.idpSelect.selectOptions.length-1];
                } 
            }
            if($scope.idpSelect.selectOptions.length===0){
                $scope.idpAccountInput.error = $scope.errorMsgObj['noIdps'];
            } else {
                if(!$scope.idpSelect.defaultOption.id){
                    $scope.idpSelect.defaultOption = $scope.idpSelect.selectOptions[0];
                }
                $scope.idpSelect.disable = false;
            }
                
            if (!$scope.$$phase) {
                $scope.$apply();
            }
        }, function (data) {
            var response = typeof data.responseText === 'object' ? data.responseText : $.parseJSON(data.responseText);
            if(response.error_code === 'IAM.0004')response.error_code = 'noIdps';
            if(response.lock_time) response.error_code = 'idpIpLock';
            $scope.idpAccountInput.error = $scope.getErrorInfo(response.error_code);
            if(response.lock_time) $scope.idpAccountInput.error = iamUtils.i18nFormat($scope.idpAccountInput.error, response.lock_time);
            if (!$scope.$$phase) {
                $scope.$apply();
            }
        });
    }
        
    function initIAMInput($scope){
        if($scope.model.loginType === 'iam' && (cookieOp.getCookie('findPwdEnd')==='ok' || cookieOp.getCookie('rememberChecked'))){
            $scope.IAMAccountInput.value = cookieOp.getCookie('IAMAccount');
            $scope.IAMUsernameInput.value = cookieOp.getCookie('IAMUsername');
            loginVerify($scope);
        }
    }
        

    loginCtrl = ['$scope', '$sce', '$filter', '$interval', '$timeout', 'securityPolicy', '$state', loginCtrl];
    var loginModule = angular.module('authui.config');
    loginModule.controller('authui.login.ctrl', loginCtrl);

    return loginCtrl;
}), define(['authui/login/controllers/loginController'], function () { });



// WEBPACK FOOTER //
// ./public/hws/js/login/controllers/loginController.js